var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_5276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8905 5.47889C12.7828 5.48154 12.6783 5.51637 12.5905 5.57889C12.3962 5.75105 12.3698 6.04493 12.5305 6.24889L16.9905 12.1089C17.0216 12.1491 17.0391 12.1981 17.0405 12.2489C17.0405 12.303 17.023 12.3556 16.9905 12.3989L12.5305 18.2489C12.4911 18.2963 12.4606 18.3505 12.4405 18.4089C12.4306 18.4685 12.4306 18.5293 12.4405 18.5889C12.4515 18.6515 12.4717 18.7122 12.5005 18.7689C12.5283 18.8219 12.5656 18.8693 12.6105 18.9089C12.6584 18.9453 12.7126 18.9725 12.7705 18.9889C12.8296 19.0037 12.8914 19.0037 12.9505 18.9889C13.0102 18.9978 13.0708 18.9978 13.1305 18.9889C13.1838 18.9574 13.2312 18.9168 13.2705 18.8689L17.7305 12.9889C18.0898 12.5723 18.0898 11.9554 17.7305 11.5389L13.2505 5.64889C13.2072 5.59448 13.1526 5.55012 13.0905 5.51889C13.0275 5.49138 12.9593 5.47774 12.8905 5.47889Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89051 5.47889C7.78277 5.48154 7.67829 5.51637 7.59051 5.57889C7.39616 5.75105 7.36984 6.04493 7.53051 6.24889L11.9905 12.1089C12.0216 12.1491 12.0391 12.1981 12.0405 12.2489C12.0405 12.303 12.023 12.3556 11.9905 12.3989L7.53051 18.2489C7.49108 18.2963 7.46059 18.3505 7.44051 18.4089C7.43063 18.4685 7.43063 18.5293 7.44051 18.5889C7.45146 18.6515 7.47168 18.7122 7.50051 18.7689C7.52832 18.8219 7.5656 18.8693 7.61051 18.9089C7.65836 18.9453 7.71263 18.9725 7.77051 18.9889C7.8296 19.0037 7.89142 19.0037 7.95051 18.9889C8.01018 18.9978 8.07084 18.9978 8.13051 18.9889C8.18383 18.9574 8.23121 18.9168 8.27051 18.8689L12.7305 12.9889C13.0898 12.5723 13.0898 11.9554 12.7305 11.5389L8.25051 5.64889C8.20722 5.59448 8.15263 5.55012 8.09051 5.51889C8.02748 5.49138 7.95927 5.47774 7.89051 5.47889Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_5276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRight);
export default __webpack_public_path__ + "static/media/arrows-right.eb1e4c7d.svg";
export { ForwardRef as ReactComponent };